var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationChartAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M69 70H11V59h2v9h54V32h2v38M13 47h-2V10h58v10h-2v-8H13v35",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M50.707 44.707l-1.414-1.414 16-16 1.414 1.414-16 16M44.293 44.707l-10-10 1.414-1.414 10 10-1.414 1.414M14.707 51.707l-1.414-1.414 17-17 1.414 1.414-17 17",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 51c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zM33 30c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zM48 44c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zM68 24c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M17 18h2v-2h-2zM17 22h2v-2h-2zM15 66h2v-8h-2zM19 66h2V50h-2zM43 66h2V51h-2zM47 66h2V52h-2zM51 66h2V51h-2zM55 66h2V43h-2zM59 66h2V39h-2zM63 66h2V35h-2zM23 66h2V46h-2zM27 66h2V42h-2zM39 66h2V44h-2zM35 66h2V40h-2zM31 66h2V38h-2zM35 18h26v-2H35zM21 18h12v-2H21zM21 22h30v-2H21z",
    className: "fi-icon-illustrative-base-fill"
  }))));
}

export default SvgIconIllustrationChartAnalytics;